// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/styles/FileIcon.scss
// module id = 1493
// module chunks = 0